
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.5 30c-.078-.134-1.92-3.283-1.92-4.3a1.921 1.921 0 013.842 0c0 1.02-1.842 4.169-1.92 4.3zm0-7.112a3.3 3.3 0 01-3.312-2.968H7a7.519 7.519 0 012.108-5.3 7.96 7.96 0 01-.117-1.354 18.5 18.5 0 012.755-10.211A11.425 11.425 0 0114.5 0a11.686 11.686 0 012.755 3.085 18.659 18.659 0 012.754 10.243 7.081 7.081 0 01-.117 1.283A7.537 7.537 0 0122 19.92h-4.188a3.3 3.3 0 01-3.312 2.968zm0-15.119a2.3 2.3 0 102.321 2.3 2.312 2.312 0 00-2.321-2.3z","fill":"#222"}})])
          )
        }
      }
    